import {useState, useEffect} from "react";
import {Layout, LayoutChild} from '../../../../../palette/Palette';
import {Filters, generateUUID} from '../../../../../utils/HelpFunctions';
import DashedLine from '../../../../../palette/DashedLine';
import {Button} from 'devextreme-react/button';
import {useSnackbar} from 'notistack';
import {ErrorMessage, NotiStackInfo} from "../../../../../palette/NotiStackInfo";
import axios from 'axios';
import ComponentLoadPanel from '../../../../../palette/LoadPanel';
import format from "date-fns/format";
import {es} from "date-fns/locale";
import Text from "../../../../../palette/Text";
import VerticalSpace from "../../../../../palette/VerticalSpace";
import TextArea from 'devextreme-react/text-area';
import Invoice from "../Invoice";
import {customScroll} from "../../../../../utils/Scroll";
import {Element} from 'react-scroll'
import Alerts from "../../../../../palette/Alerts";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

//const url = 'http://192.168.100.3:8082/parcels';

const url = 'https://parcels-easi4xatjq-uc.a.run.app/parcels';


function Details(props) {

    const {
        total, vehicleData, hour, valueDate, exists, dataPassengers, getCoordsClient, driver, DataStore,
        providerPercentage, tripStartControl, contactNumbers, tokenPush, setVisibleGrid, setParcels, photo
    } = props;

    /*Ingresar uid*/

    const {companyName, idCompany} = DataStore
    const logoUrl = DataStore.imageAsUrl;

    const [detailValue, setDetailValue] = useState('');
    const [error, setError] = useState(false);
    const [showPanel, setShowPanel] = useState(false);
    const [invoice, setInvoice] = useState({
        name: `${dataPassengers.name} ${dataPassengers.lastName}`,
        RUC: dataPassengers.idUser,
        contactNumber: dataPassengers.contactNumber,
        email: dataPassengers.email,
        address: '',
    });

    const [popupVisible, setPopupVisible] = useState(false);
    const [success, setSuccess] = useState(false);

    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        setShowPanel(false)
        customScroll('bottom-element', 500)
    }, [])

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar encomienda"
                    onClick={() => {
                        setVisibleGrid(true)
                        setParcels(false)
                    }}/>
        )
    }

    const onSaveReservation = async () => {
        if (detailValue !== '') {
            setError(false);

            const contactNumber = dataPassengers.contactNumber

            const travelStatusUid = generateUUID();

            setShowPanel(true);

            const dateStr = format(valueDate, 'yyyy-MM-dd');
            const dateArray = dateStr.split('-')
            const num = Math.floor(Math.random() * 100) + 1
            const cod = `${dateArray[1]}${dateArray[dateArray.length - 1]}${num.toString()}`/*Codigo de la encomienda*/

            if (!vehicleData.exists) {

                const parcels = [{
                    cod: cod,
                    name: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    paymentValue: total.toFixed(2),
                    contactNumber: dataPassengers.contactNumber,
                    coords: getCoordsClient,
                    paymentStatus: false,
                    passengerUid: null,
                    check: true,
                    details: detailValue,
                    typeReservation: 'parcel-manual',
                }];

                const numberParcels = vehicleData.numberParcels - 1;

                const newObject = {
                    cod: cod,
                    availableSeats: vehicleData.availableSeats,
                    date: format(valueDate, 'yyyy-MM-dd'),
                    driver: driver,
                    photo: photo,
                    driverId: vehicleData.driverId,
                    travelStatusUid: travelStatusUid,
                    contactNumber: vehicleData.contactNumber,
                    tripStartControl: tripStartControl,
                    providerPercentage: providerPercentage,
                    hour: hour,
                    tokenPush: [tokenPush],
                    color: vehicleData.color,
                    brand: vehicleData.brand,
                    type_vehicle: vehicleData.type_vehicle,
                    valueAdded: vehicleData.valueAdded,
                    rate: vehicleData.rate,
                    exists: vehicleData.exists,
                    description: vehicleData.description,
                    columns: vehicleData.columns,
                    numberParcels: numberParcels,
                    commissionRate: vehicleData.commissionRate,
                    plateNumber: vehicleData.plateNumber,
                    routeName: vehicleData.routeName,
                    passengers: [],
                    seating: vehicleData.seating,
                    parcels: parcels,
                    type: 'programmed',
                    typeReservation: 'manual',
                    statusTrip: true,
                    baggage: false,
                };

                const formatDate = newObject.date.replaceAll('-', '/')
                const date = new Date(formatDate)
                const year = format(date, 'yyyy');
                const month = format(date, 'MMMM', {locale: es});

                const routeName = newObject.routeName.split('-')

                const dataParcel = Filters(newObject.parcels, "contactNumber", contactNumber)

                const bookingHistory = {
                    cod: cod,
                    date: newObject.date,
                    driver: newObject.driver,
                    driverId: newObject.driverId,
                    routeName: newObject.routeName,
                    type: 'E',
                    typeBooking: 'M',
                    passenger: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    numberSeats: 0,
                    numberParcels: 1,
                    paymentValue: parcels[0].paymentValue,
                    travelStatusUid: newObject.travelStatusUid,
                    status: 'Confirmado',
                    statusTrip: 'Programado',
                    year: year,
                    month: month,
                    hour: hour,
                    origen: dataParcel[0].coords.origenDirection,
                    destination: dataParcel[0].coords.destinationDirection,
                    plateNumber: newObject.plateNumber,
                    color: newObject.color,
                    brand: newObject.brand,
                    observation: dataParcel[0].details,
                    wayPay: 'Efectivo',
                    invoice: invoice,
                    observationBooking: []
                }

                const travelStatus = {
                    cod: cod,
                    date: newObject.date,
                    driver: newObject.driver,
                    driverId: newObject.driverId,
                    travelStatusUid: travelStatusUid,
                    plateNumber: newObject.plateNumber,
                    contactNumber: newObject.contactNumber,
                    origen: routeName[0],
                    destination: routeName[1],
                    hour: hour,
                    numberPassengers: 0,
                    totalParcels: newObject.parcels.length,
                    onBoard: 0,
                    year: year,
                    month: month,
                    status: 'Programado',
                }

                const data = {
                    companyName: companyName,
                    idCompany: idCompany,
                    data: newObject,
                    logoUrl: logoUrl,
                    contactNumbers: contactNumbers,
                    passenger: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    tokenPush: tokenPush,
                    hour: hour,
                    toMail: dataPassengers.email,
                    exists: exists,
                    content: detailValue,
                    travelStatus: travelStatus,
                    bookingHistory: bookingHistory
                };

                await axios.post(url, data, {headers: headers})
                    .then(async res => {
                        if (res.data === 'OK' || res.data === 'NSP') {
                            setShowPanel(false);
                            setSuccess(true)
                            customScroll('bottom-element', 500)
                            setTimeout(() => {
                                setSuccess(false)
                                setVisibleGrid(true)
                                setParcels(false)
                            }, 2000)
                        }

                        if (res.data === 'NM') {
                            setShowPanel(false);
                            NotiStackInfo('Se ha generado la encomienda, pero el correo electrónico no ha sido enviado', 'warning', enqueueSnackbar);
                            setSuccess(false)
                            setParcels(false)
                            setVisibleGrid(true)
                        }

                        if (res.data === 'NG') {
                            setSuccess(false)
                            setShowPanel(false);
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                        }
                    }).catch(() => {
                        setSuccess(false)
                        setShowPanel(false);
                        NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                    });
            } else {

                const parcelsData = {
                    cod: cod,
                    name: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    paymentValue: total.toFixed(2),
                    contactNumber: dataPassengers.contactNumber,
                    coords: getCoordsClient,
                    paymentStatus: false,
                    passengerUid: null,
                    check: true,
                    details: detailValue,
                    typeReservation: 'parcel-manual',
                };

                const numberParcels = vehicleData.numberParcels - 1;

                const parcels = [...vehicleData.parcels];
                parcels.push(parcelsData);

                const newObject = {
                    ...vehicleData, parcels: parcels, numberParcels: numberParcels, type: 'programmed', baggage: false,
                    tripStartControl: tripStartControl, providerPercentage: providerPercentage, photo: photo,
                };

                const formatDate = newObject.date.replaceAll('-', '/')
                const date = new Date(formatDate)
                const year = format(date, 'yyyy');
                const month = format(date, 'MMMM', {locale: es});

                const routeName = newObject.routeName.split('-')

                const totalSeats = Filters(newObject.seating, 'reservation', true)

                const dataParcel = Filters(newObject.parcels, "contactNumber", contactNumber)

                let direction;
                let detail;

                if (dataParcel.length > 1) {
                    direction = dataParcel[dataParcel.length - 1].coords
                    detail = dataParcel[dataParcel.length - 1].details
                } else {
                    direction = dataParcel[0].coords
                    detail = dataParcel[0].details
                }

                const bookingHistory = {
                    cod: cod,
                    date: newObject.date,
                    driver: newObject.driver,
                    photo: photo,
                    driverId: newObject.driverId,
                    routeName: newObject.routeName,
                    travelStatusUid: newObject.travelStatusUid,
                    type: 'E',
                    typeBooking: 'M',
                    passenger: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    numberSeats: 0,
                    numberParcels: 1,
                    paymentValue: parcelsData.paymentValue,
                    status: 'Confirmado',
                    statusTrip: 'Programado',
                    year: year,
                    month: month,
                    origen: direction.origenDirection,
                    destination: direction.destinationDirection,
                    plateNumber: newObject.plateNumber,
                    hour: hour,
                    color: newObject.color,
                    brand: newObject.brand,
                    observation: detail,
                    wayPay: 'Efectivo',
                    invoice: invoice,
                    observationBooking: []
                }

                const travelStatus = {
                    cod: cod,
                    date: newObject.date,
                    driver: newObject.driver,
                    driverId: newObject.driverId,
                    travelStatusUid: newObject.travelStatusUid,
                    plateNumber: newObject.plateNumber,
                    contactNumber: newObject.contactNumber,
                    origen: routeName[0],
                    destination: routeName[1],
                    hour: hour,
                    numberPassengers: totalSeats.length,
                    totalParcels: newObject.parcels.length,
                    onBoard: 0,
                    year: year,
                    month: month,
                    status: 'Programado',
                }

                const data = {
                    companyName: companyName,
                    idCompany: idCompany,
                    data: newObject,
                    hour: hour,
                    toMail: dataPassengers.email,
                    logoUrl: logoUrl,
                    contactNumbers: contactNumbers,
                    tokenPush: tokenPush,
                    passenger: `${dataPassengers.name} ${dataPassengers.lastName}`,
                    exists: exists,
                    content: detailValue,
                    travelStatus: travelStatus,
                    bookingHistory: bookingHistory
                };

                await axios.post(url, data, {headers: headers})
                    .then(async res => {
                        console.log(res.data)
                        if (res.data === 'OK' || res.data === 'NSP') {
                            setShowPanel(false);
                            setSuccess(true)
                            customScroll('bottom-element', 500)
                            setTimeout(() => {
                                setSuccess(false)
                                setVisibleGrid(true)
                                setParcels(false)
                            }, 2000)
                        }

                        if (res.data === 'NM') {
                            setShowPanel(false);
                            NotiStackInfo('Se ha generado la encomienda, pero el correo electronico no ha sido enviado', 'warning', enqueueSnackbar);
                            setSuccess(false)
                            setParcels(false)
                            setVisibleGrid(true)
                        }

                        if (res.data === 'NG') {
                            setSuccess(false)
                            setShowPanel(false);
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                        }
                    }).catch((e) => {
                        console.log(e)
                        setSuccess(false)
                        setShowPanel(false);
                        NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                    });
            }
        } else {
            setShowPanel(false);
            setError(true);
        }
    }

    return (
        <Layout>
            <Alerts severity={'error'}
                    body={'No se puede enviar sustancias ilícitas, ni material explosivo\n' +
                    'o armas u otros objetos prohibidos por la ley. El peso máximo es de 4 kilos\n'}/>
            <Invoice setInvoice={setInvoice} invoice={invoice} setPopupVisible={setPopupVisible}
                     popupVisible={popupVisible}/>

            <LayoutChild center percent={100} padding={15} row color={'#EEF4FD'}>
                <LayoutChild percent={50}>
                    <Text hover={false} text={`Encominenda enviada por`} size={16} weight={'700'}/>
                    <Text hover={false} text={`${dataPassengers?.name} ${dataPassengers?.lastName}`} size={14}/>
                    <Text hover={false} text={`${getCoordsClient?.origenCity} `} size={11}/>
                    <Text hover={false} text={`${format(valueDate, 'yyyy-MM-dd')} `} size={11}/>
                </LayoutChild>
                <LayoutChild percent={50} row space>
                    <Layout column>
                        <Text hover={false} text={`Destino ${getCoordsClient.destinyCity}`} size={14} weight={'700'}/>
                        <Text hover={false} text={`Transportado por ${driver} `} size={12}/>
                    </Layout>
                    <Button icon="far fa-file-alt" text="Factura" onClick={() => setPopupVisible(true)}
                    />
                </LayoutChild>
            </LayoutChild>
            <LayoutChild top={2} column padding={10}>
                <Text hover={false} text={`Observaciones`} size={12}/>
                <TextArea
                    height={90}
                    width={'100%'}
                    placeholder="Ingresar el detalle de la encomienda, nombre y número de contacto de quién la recibe."
                    onValueChanged={(e) => {
                        setError(false);
                        setDetailValue(e.value);
                    }}
                    onFocusIn={() => setError(false)}
                    value={detailValue}/>
                {error && <Text hover={false} text={`Ingrese los detalles de la encomienda.`} size={9} color={'red'}/>}
            </LayoutChild>

            <LayoutChild color={'transparent'} top={2} padding={15}>
                <DashedLine/>
                <VerticalSpace space={10}/>
                <Layout row space>
                    <Text hover={false} text={`Valor de la encomienda`} size={14} weight={'700'}/>
                    <Text hover={false} text={`$ ${total.toFixed(2)}`} size={14} weight={'600'}/>
                </Layout>
                <VerticalSpace space={10}/>
                <DashedLine/>
                <VerticalSpace space={20}/>
                <Layout color={'transparent'} row center space>
                    <Text hover={false} size={12} text={'Forma de pago'} weight={'500'}/>
                    <Text hover={false} size={12} text={'Efectivo'} weight={'400'}/>
                    <LayoutChild color={'transparent'} row center>
                        <Text hover={false} size={14} text={'Total a pagar :'} weight={'700'}/>
                        <Text hover={false} size={14} text={`$ ${total.toFixed(2)}`} weight={'700'}
                              color={'#32B859'} left={7}/>
                    </LayoutChild>
                </Layout>
                <VerticalSpace space={15}/>
                {success && <Alerts severity={'success'} body={'Encomienda generada exitosamente'}/>}
            </LayoutChild>
            <LayoutChild percent={100} padding={15} row positionR>
                {renderCancelButton()}
                <Button icon="far fa-check-circle" text="Crear" width={150} id={'button-save'}
                        onClick={onSaveReservation} type='success'/>
            </LayoutChild>
            <Element name="bottom-element" className="element"/>
            <ComponentLoadPanel showLoadPanel={showPanel} message={'Creando encomienda...'} time={4000}/>
        </Layout>
    )
}

export default Details
